export const QUERY__USERS = 'users';
export const QUERY__USER_CURRENCY = 'user-currency';
export const QUERY__USER_EXT_DATA = 'user-ext-data';
export const QUERY__USER_EXT_DATA_BY_NAME = 'user-ext-data-by-name';
export const QUERY__USER_BANS = 'user-bans';
